import dynamic from 'next/dynamic';
import { useCallback, useEffect } from 'react';

// Client Store
import { MODAL_LOGIN_PASSCODE, useGetModalDataByName, useModalStoreActions } from '@store/client/store.modals';

// Hooks
import { useCountdownTimer } from './LoginPasscode.hooks';

// Styles
import styles from '../modal.module.scss';

// Dynamic Components
// Dynamically load the Modal component
const Modal = dynamic(() => import('ht-styleguide').then(mod => mod.Modal), { ssr: false });
// @ts-ignore
const LoginPasscodeForm = dynamic(() => import('./LoginPasscode.Form').then(mod => mod.LoginPasscodeForm), { ssr: false });

export const LoginPasscodeModal = () => {
  /* Hooks */
  const { updateAppLevelModal } = useModalStoreActions();
  const modalData = useGetModalDataByName(MODAL_LOGIN_PASSCODE);
  const { startTimer, remainingTime, canResend } = useCountdownTimer();

  /* Constants */
  const isModalOpen = modalData?.visible;

  /* Methods */
  const onResendPasscodeSuccess = useCallback(() => {
    startTimer({ startFromBeginning: true });
  }, [startTimer]);

  useEffect(() => {
    if (isModalOpen) {
      startTimer();
    }
  }, [isModalOpen, startTimer]);

  if (!isModalOpen) return null;

  return (
    <Modal
      isVisible={isModalOpen}
      hide={() => updateAppLevelModal({ name: MODAL_LOGIN_PASSCODE, visible: false })}
      header="Confirm it's you"
      headerClasses={styles.passcodeModalHeaderContainer}
      elementSize={'medium' as any}
    >
      <LoginPasscodeForm onResendSuccess={onResendPasscodeSuccess} remainingTime={remainingTime} canResend={canResend} />
    </Modal>
  );
};
